import axios from "axios";
import { urls } from "../../utils/AppManager";
import { getAuthHeaders } from "../../utils/headers";

export const getSMSTemplatesList = async (
    payload,
    fromDate,
    toDate,
) => {
    const body = {
        pageNumber: payload.currentPage,
        pageSize: payload.recordsPerPage,
        fromDate: fromDate,
        toDate: toDate,
        searchQuery: payload?.searchQuery || "",
    }

    const url = `${process.env.REACT_APP_API_BASE_URL}${urls.smsTemplatesList}`;

    const headers = {
        ...getAuthHeaders(),
        "Content-Type": "application/json",
    };

    try {
        const response = await axios.post(url, body, { headers });
        return response?.data;
    } catch (error) {
        console.error("Error fetching sms templates list", error);
        throw error;
    }
}

export const createSMSTemplate = async (payload) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}${urls.createSMSTemplate}`;

    const headers = {
        ...getAuthHeaders(),
        "Content-Type": "application/json",
    };

    const body = {
        smstemplatename: payload.smstemplatename,
        smstemplatetext: payload.smstemplatetext,
        smsproviderid: payload.smsproviderid,
        smstemplateid: payload.smstemplateid,
        tracklinkid: payload.tracklinkid,
        isactive: payload.isactive ?? true,
    };

    try {
        const response = await axios.post(url, body, { headers });
        return response?.data;
    } catch (error) {
        console.error("Error creating sms template", error);
        throw error;
    }
}

export const getSMSProviderMaster = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.smsProviderMaster;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};